import {Component, OnInit, ViewChild} from '@angular/core';
import { ApiClientService } from '../../../../services/api-client.service';
import { AuthenticationService } from '../../../../services/authentication.service';
import { UrlService } from '../../../../services/url.service';
import { NgForm } from '@angular/forms';
import { ConstantsService } from '../../../../services/constants.service';
import { PropertyService } from '../services/property.service';


declare const toastr: any;
declare const $: any;
declare const swal: any;

@Component({
    selector: 'invitation-email-modal',
    templateUrl: './invitation-email-modal.component.html',
    styleUrls: ['./invitation-email-modal.component.scss']
})
export class InvitationEmailModalComponent implements OnInit {
    @ViewChild('form') form;
    showModal = false;
    disabledSubmit = false;
    showEditPanel = false;
    invitationSubject = '';
    invitationEmail = '';
    placeholders = [
        '[[RESIDENT_NAME]]',
        '[[RESIDENT_EMAIL]]',
        '[[RESIDENT_MOBILE_PHONE]]',
        '[[RESIDENT_HOME_PHONE]]',
        '[[RESIDENT_BUSINESS_PHONE]]',
        '[[BUILDING_NAME]]',
        '[[BUILDING_ADDRESS]]',
        '[[INVITATION_LINK]]',
        '[[MY_SIGNATURE]]',
        '[[DATA_CONFIRMATION_LINK]]',
        '[[MCC_INVITATION_LINK]]'
    ];

    constructor(
        public api: ApiClientService,
        public propertyService: PropertyService,
        public authService: AuthenticationService,
        public urlService: UrlService
    ) {}

    ngOnInit() {
        this.initData();
        setTimeout( () => this.showModal = true, 300);
    }

    initData() {
        this.invitationEmail = this.propertyService.selectedItemData.corporationNumber ? (<any>this.propertyService.selectedItemData.corporationNumber).inviteTemplate  : '';
        this.invitationSubject = this.propertyService.selectedItemData.corporationNumber ? (<any>this.propertyService.selectedItemData.corporationNumber).inviteSubject  : '';
    }

    hideModal() {
        if (this.showEditPanel) {
            swal(ConstantsService.getSwalConfig('Close without saving?', 'Do you want to delete unsaved data?'),
                () => this.propertyService.isInvitationEmailModalShow = false
            );
        } else
            this.propertyService.isInvitationEmailModalShow = false;
    }

    getPlaceholdersHtml(): string {
        return this.placeholders.map(item => `<li><a>${item}</a></li>`).join('');
    }

    onSubmit(form: NgForm) {
        if(this.invitationEmail == '' || (this.invitationEmail.replace(/&nbsp;/g, '')).replace(/\s/g, '').replace(/<br>/g, '') == '') {
            toastr.warning('Invitation Email should not be blank.');
            return;
        }

        const data = {
            inviteTemplate : this.invitationEmail,
            inviteSubject: this.invitationSubject
        };
        this.disabledSubmit = true;
        const url = `/v1/corporation_number/${(<any>this.propertyService.selectedItemData.corporationNumber).id}`;
        this.api.patch('domainBD', url, data).subscribe(
            () => {
                toastr.success('Invite Template has been modified successfully.');
                (<any>this.propertyService.selectedItemData.corporationNumber).inviteTemplate = this.invitationEmail;
                (<any>this.propertyService.selectedItemData.corporationNumber).inviteSubject = this.invitationSubject;
                const itemInList = this.propertyService.data.find(item => item.id == this.propertyService.selectedItemData.id);
                if(itemInList) {
                    (<any>itemInList.corporationNumber).inviteTemplate = this.invitationEmail;
                    (<any>itemInList.corporationNumber).inviteSubject = this.invitationSubject;
                }
                this.propertyService.isInvitationEmailModalShow = false;
            },
            error => {
                this.disabledSubmit = false;
                this.api.errorHandler(error, 'Failed get buildings');
            }
        );
    }

    updateView(msg: string): void {
        toastr.success(msg);
        this.propertyService.getBuildingInfo();
        this.form.reset();
        this.hideModal();
    }

    initSummernote(id) {
        const summernote = $(id);
        summernote.summernote({
            dialogsInBody: true,
            callbacks: { onChange: contents => this.invitationEmail = contents },
            toolbar: [
                ['style', ['style']],
                ['fontsize', ['fontsize']],
                ['font', ['bold', 'italic', 'underline', 'clear']],
                ['fontname', ['fontname']],
                ['color', ['color']],
                ['para', ['ul', 'ol', 'paragraph']],
                ['table', ['table']],
                ['insert', ['link', 'hr']],
                ['help', ['help']]
            ],
            fontNames: ['Arial', 'open sans', 'Courier New'],
            disableDragAndDrop: true
        });
        $('.note-btn-bold').removeClass('active');

        const btn = `
            <div class="input-group-btn email-placeholders-btn">
                <button data-toggle="dropdown" class="btn btn-sm btn-white dropdown-toggle"
                        type="button" aria-expanded="false">PL <span class="caret"></span></button>
                <ul class="dropdown-menu pull-right">${this.getPlaceholdersHtml()}</ul>
            </div>
        `;

        $(btn).insertAfter('[data-original-title="Help"]')
            .on('click', 'li a', e => {
                summernote.summernote('editor.restoreRange');
                summernote.summernote('editor.focus');
                summernote.summernote('editor.insertText', e.target.innerText);
            });
        $('.note-editable').html(this.invitationEmail).on('focusout', e => {
            if ($(e.relatedTarget).closest('.note-toolbar').length) {
                summernote.summernote('editor.saveRange');
            }
        });
        $('.note-editable').html(this.invitationEmail).on('focusout', e => {
            if ($(e.relatedTarget).closest('.note-toolbar').length) {
                summernote.summernote('editor.saveRange');
            }
        });
    }

    showEditPanelSetter(): void {
        this.showEditPanel = true;
        setTimeout( () => this.initSummernote('#summernote'), 300);
    }

    closeEditPanel() {
        this.showEditPanel = false;
        this.invitationEmail = this.propertyService.currentWelcomeMessage ? this.propertyService.currentWelcomeMessage.slice() : '';
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/admin/property/invitation-email-modal/invitation-email-modal.component.ts